import type { Timestamp } from 'firebase/firestore';

/** Firestore `events` koleksiyonu */
export interface CommunityEventDoc {
  id: string;
  title: string;
  /** Etkinlik anı */
  eventAt: Timestamp;
  venueName: string;
  category: string;
  city: string;
  district: string;
  createdBy: string;
  createdAt: Timestamp;
  participants: string[];
}

export type MarketplaceListingStatus = 'active' | 'sold' | 'inactive';

/** Firestore `marketplace` koleksiyonu */
export interface MarketplaceListingDoc {
  id: string;
  title: string;
  description: string;
  /** Giyim, Oyuncak, … */
  category: string;
  /** Kuruş cinsinden değil; gösterim için TL (0 = ücretsiz / bağış) */
  price: number;
  isDonation: boolean;
  /** Örn. İyi, Az kullanılmış — eski ilanlar için */
  condition: string;
  city: string;
  district: string;
  sellerId: string;
  createdAt: Timestamp;
  /** Cloudinary (ve benzeri) HTTPS URL’leri; yeni ilanlarda en az 1 */
  images?: string[];
  /** Eksik eski kayıtlar aktif kabul edilir */
  status?: MarketplaceListingStatus;
  /** Takasa açık ilanlar */
  isTradeable?: boolean;
}

export const MARKETPLACE_CATEGORIES = [
  'Giyim',
  'Oyuncak',
  'Araç-Gereç',
  'Diğer',
] as const;

export type MarketplaceCategory = (typeof MARKETPLACE_CATEGORIES)[number];

export type CreateEventInput = {
  title: string;
  venueName: string;
  category: string;
  city: string;
  district: string;
  /** Yerel veya ISO string; serviste Timestamp'e çevrilir */
  eventAt: Date;
};

export type CreateListingInput = {
  title: string;
  description: string;
  category: MarketplaceCategory;
  price: number;
  isDonation: boolean;
  city: string;
  district: string;
  /** 1–3 adet görsel URL (Cloudinary) */
  images: string[];
  isTradeable: boolean;
};

export type UpdateListingInput = {
  title: string;
  description: string;
  category: MarketplaceCategory;
  price: number;
  isDonation: boolean;
  isTradeable: boolean;
};

export const EVENT_CATEGORIES = [
  'Park buluşması',
  'Kahve',
  'Yürüyüş',
  'Oyun tarihi',
  'Diğer',
] as const;

export type EventCategory = (typeof EVENT_CATEGORIES)[number];
